import { ErrorMessage, Field, Form } from 'formik';

import { Button, ButtonWrapper, Error, FormRow, Input, Label } from '../components';

type ChangeEmailModalProps = {
    changeLoading: boolean;
};

const ChangeEmailModal = ({ changeLoading }: ChangeEmailModalProps) => (
    <Form noValidate autoComplete="on">
        <FormRow>
            <Label>Your e-mail</Label>
            <Field
                as={Input}
                autoComplete="email"
                type="email"
                autoFocus
                name="email"
                id="email"
                placeholder="you@company.com"
            />
            <ErrorMessage name="email" component={Error} />
        </FormRow>
        <ButtonWrapper>
            <Button loading={changeLoading} loadingText="Sending" type="submit">
                Resend activation email
            </Button>
        </ButtonWrapper>
    </Form>
);

export default ChangeEmailModal;
